import React from 'react';

import useNotification from '../../hooks/useNotification';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setOpenNotificationDrawer } from './NotificationSlice';
import NotificationDrawer from './NotificationDrawer';
import LogoutModal from './LogoutModal';

const Notification = () => {
  const dispatch = useAppDispatch();
  const { totalUnread } = useAppSelector((state) => state.notification);
  const {
    isShowLogoutModal,
    activePackage,
    notificationId,
    updateViewStatusNotification,
  } = useNotification();

  const handleOpen = () => {
    let check = window.location.href.includes('danh-muc-theo-doi');
    const info = {
      tab: check ? 1 : 0,
      category: 0,
    };
    dispatch(setOpenNotificationDrawer(info));
  };

  return (
    <>
      <button className="relative" onClick={() => handleOpen()}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
        </svg>
        {totalUnread ? (
          <span
            aria-hidden="true"
            className="absolute -top-2 left-1 inline-block text-xs px-[5px] py-[2px] leading-none transform translate-x-1 -translate-y-1 bg-red-600 border-2 border-white rounded-full dark:border-gray-800 text-white z-50"
          >
            {totalUnread > 9 ? '9+' : totalUnread}
          </span>
        ) : null}
      </button>
      <NotificationDrawer />
      <LogoutModal
        isShowLogoutModal={isShowLogoutModal}
        activePackage={activePackage}
        updateViewStatusNotification={updateViewStatusNotification}
        notificationId={notificationId}
      />
    </>
  );
};

export default Notification;
